/* tslint:disable */
/* eslint-disable */
export enum CreditFacilityType {
  CreditCard = 'CreditCard',
  Overdraft = 'Overdraft',
  RevolvingCreditHomeLoan = 'RevolvingCreditHomeLoan'
}
